var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FullPageLayout',{staticClass:"bg-bilpop",attrs:{"id":"bilpop-container","hide-footer":""}},[_c('Bilpop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }